var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKoala = function SvgKoala(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 66 66"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.917 65.916c18.179 0 32.916-14.737 32.916-32.916C65.833 14.82 51.096.083 32.917.083 14.737.083 0 14.82 0 33c0 18.179 14.737 32.916 32.917 32.916"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F33E4",
    d: "M39.535 39.432a2.985 2.985 0 0 0-2.972 3.13 2.97 2.97 0 0 0 2.401 2.766 2.984 2.984 0 0 0 3.56-2.919 2.97 2.97 0 0 0-1.843-2.751 3 3 0 0 0-1.146-.226"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F33E4",
    d: "M32.917.083a32.917 32.917 0 1 0 0 65.833 32.917 32.917 0 0 0 0-65.833m26.127 45.741a6.639 6.639 0 0 0-12.432 3.257v9.613a29 29 0 0 1-12.776 3.43A27.1 27.1 0 0 1 26.98 42.6a26.56 26.56 0 0 1 4.54-13.228.274.274 0 0 0-.044-.37.3.3 0 0 0-.356.035 21.38 21.38 0 0 0-7.61 13.315 32 32 0 0 0-.248 1.703c0 .191-.274.24-.39.204a14.91 14.91 0 1 1 16.704-22.986 1.54 1.54 0 0 0 1.255.651h18.99a29.08 29.08 0 0 1-.767 23.926z"
  })));
};
export default SvgKoala;